import React from "react";

const PackageIcon = ({ className, stroke }) => (
    <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M17.9091 13.8182H21V3H10.1818V6.09091M14.8182 16.9091H17.9091V6.09091H7.09091V9.18182M4 20H14.8182V9.18182H4V20Z"
            stroke={stroke || "#0087EE"}
            stroke-width="1.57765"
        />
    </svg>
);

export default PackageIcon;
